import React from 'react'

function MutedText({ as: Component = 'span', lighter = false, className = '', children, ...props }) {
  const weight = lighter ? 'fw-lighter' : 'fw-light'
  return (
    <Component className={`text-muted ${weight} ${className}`.trim()} {...props}>
      {children}
    </Component>
  )
}

export default MutedText
